import type { ComponentProps } from "react";

import { forwardRef } from "react";

const IconMoon = forwardRef<SVGSVGElement, ComponentProps<"svg">>(
  (props, ref) => {
    return (
      <svg
        ref={ref}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M17.5001 10.6733C17.0834 15.1292 12.6259 18.29 8.24424 17.3258C-0.0649272 15.5 0.958406 3.2575 9.25841 2.5C5.32924 7.74667 12.1826 14.5517 17.5001 10.6733Z"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
IconMoon.displayName = "IconMoon";

export { IconMoon };
